(function () {
    'use strict';

    angular
        .module('ib-globick-activities-module')
        .factory('ibGlobickActivitiesService', ibGlobickActivitiesService);

    ibGlobickActivitiesService.$inject = ['$rootScope', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy', 'AncillariesConstants', 'localStorageService'];
    function ibGlobickActivitiesService ($rootScope, CommonsNewHttpUtilsErrorService, CommonsGenericProxy, AncillariesConstants, localStorageService) {

        return {
            getTokenWidget:getTokenWidget,
            locationForWidget: locationForWidget
        };

        ////////////////
        function getTokenWidget () {
            return new Promise( (resolve, reject) => {
                const widgetProMonetate = localStorageService.get('widgetProMonetate');
                const envCopy= {};
                (Object).assign(envCopy, (window).env);
                const parameters = {
                    endpoint: '',
                    Authorization: ''
                };

                if(envCopy.production || widgetProMonetate) {
                    parameters.endpoint = AncillariesConstants.DEFAULT_ENDPOINTS.tokenActivitiesPRO;
                    parameters.Authorization = 'Basic NjNiOG5hZTMwcWRqb3VlYmFmYjdhYW4xamY6Y3FsdTcxbmgxMWhwaTMyazN2ZzcxM3BqMHIyamdsZW1wZXRhaHZncWxtZ2oydGVjcmU4';
                }else {
                    parameters.endpoint = AncillariesConstants.DEFAULT_ENDPOINTS.tokenActivitiesPREE;
                    parameters.Authorization = 'Basic M2VkdHAxNnNtbGxjMW42Y25icGdlMTBtcDU6anZ2YzBwbDZkOTFnODZmajh1b2VzcGY1b2JncmMxYjltZGtubDJjZHYzaWwxZ2p2OXY3';
                }


                const headerConfig = {
                    'headers': {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Authorization: parameters.Authorization
                    }
                };
                CommonsGenericProxy.postGeneric(parameters.endpoint, {}, headerConfig).then((response) => {
                    resolve(response);
                }, (error) => {
                    CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
            });
        }

        function locationForWidget (airport) {
            const dictionary = AncillariesConstants.diccionaryWidget;
            return dictionary[airport];
        }
    }
})();